import { mutate } from "swr";
import { endpointsViews } from "../endpoints/endpointsViews";
import { fetchApi } from "../fetcher";
import { ViewCreateFormModel } from "lib/types/views/ViewCreateFormModel";
import { ViewResponseModel } from "lib/types/views/ViewResponseModel";

export async function createView(
  projectId: number,
  model: ViewCreateFormModel,
): Promise<ViewResponseModel> {
  const response = await fetchApi({
    url: endpointsViews.views,
    method: "POST",
    body: {
      ...model,
      projectId,
    },
  });
  await mutate(
    (key) =>
      typeof key === "string" &&
      key.startsWith(endpointsViews.projectViews(projectId)),
  );
  return response.json();
}
